// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".Onboarding-module__alertBox--1P-Ml{margin-bottom:1rem;background:white;text-align:left;line-height:1.333}.Onboarding-module__alertBox--1P-Ml a{color:#0050ff;text-decoration:none}.Onboarding-module__alertBox--1P-Ml span{line-height:1rem;white-space:pre-wrap}.Onboarding-module__h1--2NTjL{color:#000;font-size:1.333rem;font-weight:700;margin-bottom:0.667rem;width:100%}@media only screen and (min-width: 768px){.Onboarding-module__h1--2NTjL{font-size:1.556rem}}.Onboarding-module__h2--2AP3-{color:#000;font-size:1rem;line-height:1.333}@media only screen and (min-width: 768px){.Onboarding-module__h2--2AP3-{font-size:1.333rem}}\n", ""]);
// Exports
exports.locals = {
	"alertBox": "Onboarding-module__alertBox--1P-Ml",
	"h1": "Onboarding-module__h1--2NTjL",
	"h2": "Onboarding-module__h2--2AP3-"
};
module.exports = exports;
